import { Link, useLocation } from "wouter";
import { db } from "../db";
import styles from "./CheckinForm.module.css";
import { Camera } from "lucide-react";

export function CheckinForm({
  id,
  position,
}: {
  id: string;
  position?: GeolocationPosition | null;
}) {
  const [, setLocation] = useLocation();

  async function submit(data: FormData) {
    if (!position) throw new Error("No location");

    const checkinId = await db.checkins.add({
      lat: position.coords.latitude,
      lon: position.coords.longitude,
      time: Date.now(),
      boxId: id,
      note: data.get("note") as string,
    });

    const photos = data
      .getAll("photos")
      .filter((p) => p instanceof File && p.size) as File[];

    if (photos.length > 0) {
      await db.media.bulkAdd(
        photos.map((file) => ({
          checkinId,
          file,
        }))
      );
    }

    setLocation("/");
  }

  return (
    <form action={submit} className={styles.form}>
      <h3 className={styles.header}>Collect this canvas</h3>

      <textarea
        name="note"
        placeholder="Notes"
        className={styles.textarea}
      ></textarea>

      <span className={styles.buttonContainer}>
        <label className={styles.photoInput}>
          <Camera />
          Add a photo
          <input
            type="file"
            name="photos"
            accept="image/*"
            capture="environment"
          />
        </label>

        <div className={styles.actions}>
          <Link
            to="/nearby"
            className={`${styles.button} ${styles.cancelButton}`}
          >
            Cancel
          </Link>

          <button className={styles.button}>Save</button>
        </div>
      </span>
    </form>
  );
}
